<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          公众号管理
          <span class="titleColor"></span> -公众号消息
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <!-- 检索 -->
      <el-form :inline="true" size="small" v-model="listQuery">

        <el-form-item label="选择任务">
          <el-select v-model="listQuery.templateId" clearable placeholder="请选任务" filterable>
            <el-option v-for="(item, index) in jobList" :key="index" :label="item.jobName" :value="item.templateId" />
          </el-select> 
        </el-form-item>
        <el-form-item label="发送时间">
            <el-date-picker  v-model="chooseTime" :picker-options="{}" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>

        <el-form-item>
          <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
        </el-form-item>

      </el-form>
      <!-- 新增 -->

      <!-- 表单 -->
      <el-table :data="listData" border class="table">
        <el-table-column prop="id" width="100" label="编号" fixed></el-table-column>
        <el-table-column prop="jobName" label="任务名称"></el-table-column>
        <el-table-column prop="workerNo" label="服务者编号"></el-table-column>

        <el-table-column prop="openId" label="openId"></el-table-column>
        <el-table-column prop="sendContent"  width="300"  label="发送内容"></el-table-column>
        <el-table-column prop="sendPagePath"   label="跳转页面"></el-table-column>
        
        <el-table-column prop="sendStatus"   label="发送状态">
          <template slot-scope="scope">
            <span v-if="scope.row.sendStatus == true">成功</span>
            <span v-if="scope.row.sendStatus == false">失败</span>
          </template>
        </el-table-column>
        <el-table-column prop="sendStatusDesc"   label="失败原因"></el-table-column> 
        <el-table-column prop="sendTime" :formatter="dateFormat" label="发送时间"></el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="querySearch" />


    </div>
  </div>
</template>
<script>
import moment from "moment";
import Pagination from "@/components/common/Pagination";
import globalData from "@/components/common/globaldata/global.data";
import service from "@/script/api/service";
export default {
  components: { Pagination },
  data() {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 10,
      listData: [],
      listQuery: {
        jobId: "",
        createTimeStart: "",
        createTimeEnd: ""
      },
      chooseTime: [],
      jobList: [],

    };
  },
  created() {

    this.querySearch();
    service.$axioWXGetAllJobList({}).then(res => {
      console.log(res);
      if (res.data.errno == 0) {
        this.jobList = res.data.data;
      } else {
        this.$message.warning(res.data.data);
      }
    });

  },
  methods: {

    //查询
    querySearch() {
      this.listQuery.pageNum = this.currentPage;
      this.listQuery.pageSize = this.pageSize;
      this.listQuery.createTimeStart='';
        this.listQuery.createTimeEnd='';
      if(this.chooseTime.length>0){
        this.listQuery.createTimeStart=this.chooseTime[0];
        this.listQuery.createTimeEnd=this.chooseTime[1];
      }
      service
        .$axioWxGetLog(this.listQuery)
        .then(res => {
          console.log(res);
          this.listData = res.data.data.list;
          this.total = res.data.data.total;
        })
        .catch(err => {
          console.log(err);
        });
    },

    //时间格式化
    dateFormat(row, column) {
      var date = row[column.property];
      if (date == undefined || date == "") {
        return "";
      }
      return moment(date).format("YYYY-MM-DD HH:mm");
    }
  }
};
</script>
<style scoped>
.el-form {
  padding: 0 60px 0 20px !important;
}

.el-select.el-select--small,
.el-input--small {
  width: 100%;
}
</style>

